import { JAPAN_NATIONALITY_ID } from "@/types/enum";

type NationalityOption = { label: string; value: string | number };

export const sortNationalityOptions = (options: NationalityOption[], talentNationalityId?: number | string | null): NationalityOption[] => {
  if (!options.length) return options;

  const normalizedTalentId = talentNationalityId != null ? Number(talentNationalityId) : null;

  return [...options].sort((a, b) => {
    const aVal = Number(a.value);
    const bVal = Number(b.value);

    const aIsTalent = normalizedTalentId != null && aVal === normalizedTalentId;
    const bIsTalent = normalizedTalentId != null && bVal === normalizedTalentId;
    const aIsJapan = aVal === JAPAN_NATIONALITY_ID;
    const bIsJapan = bVal === JAPAN_NATIONALITY_ID;

    if (aIsTalent && !bIsTalent) return -1;
    if (!aIsTalent && bIsTalent) return 1;
    if (aIsJapan && !bIsJapan) return -1;
    if (!aIsJapan && bIsJapan) return 1;

    return 0;
  });
};
